import Vue from 'vue'

const defaultOptions = {}

const AbConfig = {
  get(key) {
    if (this.state[key] === undefined) throw new Error(`AB-Config for key '${key}' not set!`)

    return this.state[key]
  },

  set(key, value) {
    switch (value) {
      case 'true':
        value = true
        break

      case 'false':
        value = false
        break
    }

    Vue.set(this.state, key, value)
  },

  install(Vue, options) {
    if (this.installed) {
      return
    }

    this.installed = true

    Vue.prototype.$abConfig = this
    this.state = Object.assign(defaultOptions, options)
    this.state = Vue.observable(this.state)
  },
}

export default AbConfig
